export const snotifyOptions = {
  toast: {
    position: 'rightBottom',
    timeout: 5000
  }
}